import { render, staticRenderFns } from "./LegalDialog.vue?vue&type=template&id=7ff6fac9&scoped=true"
import script from "./LegalDialog.vue?vue&type=script&lang=ts"
export * from "./LegalDialog.vue?vue&type=script&lang=ts"
import style0 from "./LegalDialog.vue?vue&type=style&index=0&id=7ff6fac9&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff6fac9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff6fac9')) {
      api.createRecord('7ff6fac9', component.options)
    } else {
      api.reload('7ff6fac9', component.options)
    }
    module.hot.accept("./LegalDialog.vue?vue&type=template&id=7ff6fac9&scoped=true", function () {
      api.rerender('7ff6fac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Landing/LegalDialog.vue"
export default component.exports